export const generateKey = (prefix: string, index: number) => `${prefix}-${index}`;
